export const StatsTealiumAdapterPropertySubcategoriesMapping = {
  buy: 'residential',
  rent: 'residential',
  commercial_buy: 'commercial',
  commercial_rent: 'commercial',
};
